import { render, staticRenderFns } from "./Loanables.vue?vue&type=template&id=9f8a0400"
import script from "./Loanables.vue?vue&type=script&lang=js"
export * from "./Loanables.vue?vue&type=script&lang=js"
import style0 from "./Loanables.vue?vue&type=style&index=0&id=9f8a0400&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports